module.exports = __webpack_public_path__ + "assets/images/RedPaymentShape.d33de3e333eae27c0e4f66a19e769c6b.png";